import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Notification {
  type: 'success' | 'error';
  message: string;
  details?: string;
  timestamp?: Date;
}

@Injectable({
  providedIn: 'root',
})
export class AddMessageNotificationService {
  constructor() {
    //no code
  }

  private notificationSubject = new BehaviorSubject<Notification | null>(null);

  // Observable that components can subscribe to
  notification$ = this.notificationSubject.asObservable();

  /**
   * Show success notification
   */
  showSuccess(message: string, details?: string): void {
    this.show({
      type: 'success',
      message,
      details,
      timestamp: new Date(),
    });
  }

  /**
   * Show error notification
   */
  showError(message: string, details?: string): void {
    this.show({
      type: 'error',
      message,
      details,
      timestamp: new Date(),
    });
  }

  /**
   * Show notification
   */
  private show(notification: Notification): void {
    this.notificationSubject.next(notification);
  }

  /**
   * Clear current notification
   */
  clear(): void {
    this.notificationSubject.next(null);
  }
}
